import { Typography } from "antd";

const QuizHeader = () => {
  return (
    <Typography.Title level={5} style={{ margin: 0 }}>
      Quiz Management
    </Typography.Title>
  );
};

export default QuizHeader;
